<template>
    <div class="ticket-code">
        <div class="card-bar"></div>

        <div class="whole">
            <div class="card  ql-snow">
                <div class="ql-editor" v-if="appData.title" v-html="appData.title"></div>
                <div class="user-data">
                    <div class="avatar" v-if="appData.avatar && userInfo.photo">

                        <img :src="userInfo.photo" alt="">
                    </div>
                    <div class="app-content ql-editor" v-html="appData.content"></div>
                </div>
                <div class="qrcode">
                    <div class="qrcode-content">
                        <vue-qr :text="dynamicCode" colorDark="#333" :size="170"></vue-qr>
                    </div>

                    <div class="count-down">
                        <span>(</span>
                        <span class="count">{{ count }}</span>
                        <span>)</span>
                        s后刷新
                    </div>
                </div>
                <div class="ql-snow">
                    <div class="ql-editor" v-html="appData.prompt"></div>
                </div>

            </div>
            <dashed-line :num="28"></dashed-line>
            <div class="banner" v-if="appData">
                <img :src="appData.banner" alt />
            </div>

        </div>

    </div>
</template>

<script>
import vueQr from 'vue-qr';
import DashedLine from '../../components/DashedLine.vue';
export default {
    props: {
        userInfo: {
            type: Object,
            default() {
                return null;
            },
        },
        appData: {
            type: Object,
            default() {
                return null;
            },
        },
    },
    data() {
        return {
            dynamicCode: '',
            count: 60,
        };
    },
    components: {
        vueQr,
        DashedLine,
    },
    methods: {
        // 倒计时
        Countdown() {
            setInterval(() => {
                this.count--;
                if (this.count == 0) {
                    //this.timer == null;
                    this.count = 60;
                    //clearInterval(this.timer);
                    this.getCurrentTimestamp();
                }
            }, 1000);
        },
        getCurrentTimestamp() {
            var currentTimeStamp = Math.floor(new Date().getTime() / 1000);
            this.dynamicCode = JSON.stringify({ code: this.userInfo.code, timestamp: currentTimeStamp });

            console.log('getCurrentTimestamp _  this.dynamicCode:', this.dynamicCode);
        },
    },

    mounted() {
        this.Countdown();
        this.getCurrentTimestamp();
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    },
};
</script>

<style lang="scss" scoped>
.ticket-code {
    .card-bar {
        height: 20px;
        background: #616161;
        border-radius: 20px;
        z-index: -1;
    }
    .whole {
        padding: 0 10px 10px 10px;
        .card {
            background: #fff;
            position: relative;
            padding: 16px 20px;
            margin-top: -10px;

            .user-data {
                display: flex;

                .avatar {
                    img {
                        width: 80px;
                        height: auto;
                    }
                }
                .app-content {
                    flex: 1;
                }
            }

            .prompt {
                color: #999;
                .title {
                    padding: 12px 20px 0;
                    font-size: 16px;
                    text-align: center;
                    color: #222;
                    p {
                        text-align: center;
                        padding: 6px 0;
                        span {
                            font-weight: bold;
                        }
                    }
                    p {
                    }
                }
                p {
                    text-align: center;
                }
            }
            .qrcode {
                width: 100%;
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                position: relative;
                .qrcode-content {
                    display: flex;
                    justify-content: center;
                    .qr-mask {
                        position: absolute;
                        z-index: 1;
                        top: 0;

                        left: 50%;
                        transform: translateX(-50%);
                        width: 170px;
                        height: 170px;
                        background: rgba(250, 250, 250, 0.8);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        span {
                            font-weight: bold;
                        }
                    }
                }
                .date-time {
                    font-size: 14px;
                    border-radius: 0 0 10px 10px;
                    background: #fff;
                    color: #f00;
                    padding: 0 10px;
                    text-align: center;
                    span {
                    }
                    div {
                        font-size: 18px;
                        display: flex;
                        justify-content: center;
                        .date {
                            margin-right: 20px;
                        }
                        .time {
                        }
                    }
                }
            }
        }
        .ql-snow {
        }

        .banner {
            width: 100%;
            position: relative;
            font-size: 0;
            img {
                width: 100%;
            }
        }
        .banner::after {
            position: absolute;
            left: -10px;
            top: -10px;
            content: '';
            width: 20px;
            height: 20px;
            border-radius: 20px;
            background: #f8f8f8;
        }

        .banner::before {
            position: absolute;
            right: -10px;
            top: -10px;
            content: '';
            width: 20px;
            height: 20px;
            border-radius: 20px;

            background: #f8f8f8;
        }
    }
}
</style>